<!-- 多选申请单组件 -->
<template>
  <div>
    <template v-if="datalist.length > 1">
      <el-tabs
        v-model="activeName"
        class="demo-tabs"
        closable
        @tabRemove="handleTabRemove"
      >
        <el-tab-pane
          v-for="(item, index) in datalist"
          :key="item.applicationFormId"
          :label="item.name"
          :name="item.applicationFormId"
          :stretch="true"
        >
          <component
            :is="componentToRender"
            :data="item"
            :showApplicationBtn="false"
            @success="handleSuccess"
          />
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <component
        :is="componentToRender"
        @select="handleSelectData"
        :data="datalist.length === 1 ? datalist[0] : {}"
      />
    </template>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  componentToRender: {
    type: Object, // 组件本身是一个对象
    required: true,
  },
});

const activeName = ref("");

const datalist = ref([]);
// 选择申请单
const handleSelectData = (data) => {
  datalist.value = data;
  if (data.length > 1) {
    activeName.value = data[0].applicationFormId;
  }
};

const handleTabRemove = (name) => {
  if (activeName.value !== name) {
    datalist.value = datalist.value.filter(
      (item) => item.applicationFormId !== name
    );
  } else {
    handleSuccess(name, 0);
  }
};

// 保存数据完成
const handleSuccess = (applicationFormId, index) => {
  datalist.value = datalist.value.filter(
    (item) => item.applicationFormId !== applicationFormId
  );
  if (index >= datalist.value.length) {
    activeName.value =
      datalist.value[datalist.value.length - 1].applicationFormId;
  } else {
    activeName.value = datalist.value[index].applicationFormId;
  }
};
</script>

<style lang="scss" scoped>
:deep(.el-tabs__header) {
  padding-left: 20px;
}
</style>
